import { render, staticRenderFns } from "./LabMediaAssessedCheck.vue?vue&type=template&id=b54ce1d4&scoped=true&"
import script from "./LabMediaAssessedCheck.vue?vue&type=script&lang=js&"
export * from "./LabMediaAssessedCheck.vue?vue&type=script&lang=js&"
import style0 from "./LabMediaAssessedCheck.vue?vue&type=style&index=0&id=b54ce1d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54ce1d4",
  null
  
)

export default component.exports